import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from '@emotion/styled';
import colours, { palette } from '~/utils/colours';
import { Map } from 'immutable';
import { List } from 'immutable';
import useEmbeddedItemsInfo, {
  TransparentIconWrapper,
  ColoredIconWrapper,
} from '../Pages/Editor/hooks/useEmbeddedItemsInfo';
import { EmbedType } from '~/types/models';

interface EmbeddedItemsProps {
  items: List<Map<string, unknown>>;
  onRemoveItemClick: (index: number) => void;
}

const UnorderedList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

const ListItem = styled.li`
  min-height: 50px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  justify-content: space-between;
  background: ${palette.white};
  border-bottom: 2px solid #ffffff;

  ${TransparentIconWrapper},
  ${ColoredIconWrapper} {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 27px;
    height: 27px;
  }
`;

const Name = styled.span`
  padding: 0 10px;
  text-align: center;
  color: ${colours.textDark};
  font-weight: 700;
`;

const Link = styled.a`
  color: ${colours.greyLightAlt3};
  font-size: 15px;
  &:hover {
    color: ${colours.greyDarkAlt5};
  }
`;

const EmbeddedItems = ({ items, onRemoveItemClick }: EmbeddedItemsProps) => {
  if (!items.size) {
    return null;
  }
  const { getIcon } = useEmbeddedItemsInfo();

  const removeItem = (index: number) => {
    onRemoveItemClick(index);
  };

  return (
    <UnorderedList>
      {items
        .map((item, index) => (
          <ListItem key={index}>
            {getIcon(
              item?.get('icon') as string,
              item?.get('type') as EmbedType
            )}
            <Name>{item?.get('title') as string}</Name>
            <Link href='#' onClick={() => removeItem(index as number)}>
              <FontAwesomeIcon icon={faTrash} />
            </Link>
          </ListItem>
        ))
        .toArray()}
    </UnorderedList>
  );
};

export default EmbeddedItems;
